import {
  Shield, Sparkles, Calendar, Search, Trees, Bug, Wrench,
  Building, Monitor, Home, HardHat, Droplets,
} from "lucide-react";

export type IndustryStatus = "live" | "development" | "coming";

export interface IndustryDef {
  key: string;
  name: string;
  icon: typeof Shield;
  status: IndustryStatus;
  href: string;
  color: string;
  bgColor: string;
}

export const INDUSTRIES: IndustryDef[] = [
  // Live
  { key: "security", name: "Security", icon: Shield, status: "live", href: "/industries/security", color: "text-primary", bgColor: "gradient-accent" },
  { key: "cleaning", name: "Commercial Cleaning", icon: Sparkles, status: "live", href: "/industries/cleaning", color: "text-info", bgColor: "bg-[hsl(var(--info)/0.1)]" },
  { key: "construction", name: "Construction", icon: HardHat, status: "live", href: "/industries/construction-services", color: "text-warning", bgColor: "bg-[hsl(var(--warning)/0.1)]" },
  { key: "event-staffing", name: "Event Staffing", icon: Calendar, status: "live", href: "/industries/event-staffing", color: "text-warning", bgColor: "bg-[hsl(var(--warning)/0.1)]" },
  { key: "private-investigation", name: "Private Investigation", icon: Search, status: "live", href: "/industries/private-investigation", color: "text-success", bgColor: "bg-[hsl(var(--success)/0.1)]" },
  { key: "landscaping", name: "Landscaping", icon: Trees, status: "live", href: "/industries/landscaping", color: "text-success", bgColor: "bg-[hsl(var(--success)/0.1)]" },
  { key: "pest-control", name: "Pest Control", icon: Bug, status: "live", href: "/industries/pest-control", color: "text-warning", bgColor: "bg-[hsl(var(--warning)/0.1)]" },
  // In Development
  { key: "home", name: "Home Services", icon: Home, status: "live", href: "/industries/home-services", color: "text-warning", bgColor: "bg-[hsl(var(--warning)/0.1)]" },
  { key: "power-washing", name: "Power Washing", icon: Droplets, status: "live", href: "/industries/power-washing", color: "text-info", bgColor: "bg-[hsl(var(--info)/0.1)]" },
];

export const getLiveIndustries = () => INDUSTRIES.filter((i) => i.status === "live");
